<nav class="navbar navbar-expand-lg bg-body-tertiary header-custom">
  <div class="container-fluid">
    <button type="button" class="btn btn-custom-close" (click)="toggleSidebar()">
      <img src="assets/icons/burger-icon.png" class="button-close">
    </button>
    <!-- <div class="collapse navbar-collapse" id="navbarNav"> -->
    <div class="ms-auto d-flex">
      <div class="custom-dropdown mx-2">

        <div class="position-relative">
          <button class="btn btn-success-custom" (click)="toggleDateRangePicker()" type="button">
            {{selectedDateRange}} <i class="fa-solid fa-chevron-down fa-xs"></i>
          </button>

          <div class="date-picker-wrapper" [class.show]="modalDateRangePicker" *ngIf="modalDateRangePicker">
            <app-date-range-picker (dateRangeSelected)="onDateRangeSelected($event)">
            </app-date-range-picker>
          </div>
        </div>
      </div>


      <div class="dropdown">
        <button type="button" class="btn btn-danger-custom btn-desktop" (click)="toggleIncompleteData()"
          *ngIf="isIncomplete">
          Incomplete Data <i class="fa-solid fa-chevron-down fa-xs"></i>
        </button>

        <button type="button" class="btn-mobile" (click)="toggleIncompleteData()" *ngIf="isIncomplete">
          <img src="assets/icons/incomplete-mobile.png" alt="" width="30">
        </button>

        <div *ngIf="showIncompleteData">
          <div class="incomplete-data-wrapper">
            <div class="row" *ngFor="let item of ItemData">
              <div class="col-4 col-md-4 col-lg-4 d-flex flex-column align-items-start">
                <div class="p-2 text-left-incomplete">{{ item.name }}</div>
              </div>
              <div class="col-8 col-md-8 col-lg-8 d-flex flex-column align-items-end">
                <div class="p-2 text-right-incomplete">
                  {{ item.displayData }}
                  <span *ngIf="item.incomplete_data && item.incomplete_data.trim()">
                    <span *ngIf="item.hasMore">...</span>
                    <i class="fa-solid fa-info-circle ms-1 text-info cursor-pointer" (click)="showFullData(item)"
                      [title]="item.incomplete_data" data-bs-toggle="tooltip" style="cursor: pointer;">
                    </i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mx-5 d-none d-lg-block d-xl-block">
        <a [routerLink]="['/userprofile']">
          <img [src]="itemPicture" alt="" class="rounded-circle border-light"
            style="width: 40px; height: 40px; object-fit: cover;">
        </a>
      </div>



    </div>
    <!-- </div> -->


  </div>
</nav>
